import React from 'react';
import { Avatar, AvatarProps } from '../../Avatar';
import { useCustomComponent } from '@/hooks';

export interface TypingIndicatorAvatarProps extends AvatarProps {}

const AvatarSlotComponent: React.FC<TypingIndicatorAvatarProps> = props => {
  return <Avatar {...props} />;
};

export const AvatarSlot: React.FC<TypingIndicatorAvatarProps> = (
  props: TypingIndicatorAvatarProps
) => {
  const Component = useCustomComponent({
    componentName: 'TypingIndicatorAvatar',
    Component: AvatarSlotComponent,
  });

  return <Component {...props} />;
};
